import 'Assets/styles/default/pages/viewRedemption/ViewRedemptionStyles.less';
import React, { useEffect } from 'react';
import { Typography, VertButton, VertContainer } from '@vertem-core/vertice-ds';
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';
import { useNavigate } from 'react-router';

export const SpotNotFound = ({ id }) => {
  const navigate = useNavigate();

  return (
    <VertContainer>
      <div className={'container-view-redemption'}>
        <VertContainer className="container-title-view-redemption container-spot-not-found">
          <Typography.Text className="title-view-redemption">
            Solicitação #{id}
          </Typography.Text>

          <Typography.Text className="text-spot-not-found">
            Não foi possível trazer as informações da solicitação desejada.
          </Typography.Text>

          <Row className="row-button">
            <Col xs={12} sm={10} md={10} lg={6} xl={6} xxl={6}>
              <VertButton
                type="default"
                className="button-view-redemption"
                onClick={() => navigate('/list-redemptions')}
              >
                Ver Solicitações
              </VertButton>
            </Col>
          </Row>
        </VertContainer>
      </div>
    </VertContainer>
  );
};

SpotNotFound.propTypes = {
  id: PropTypes.string.isRequired,
};
